import { createFileRoute } from "@tanstack/react-router";
import { getProfileCompletion } from "@/features/identity/records";
import { returnSearchSchema } from "@/features/identity/navigation";
import { CompleteProfilePage } from "@/features/identity";
import { VerifiedSession } from "@/session/product-session";

export const Route = createFileRoute("/_site/complete-profile")({
  validateSearch: returnSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ deps, abortController }) =>
    getProfileCompletion({ data: deps, signal: abortController.signal }),
  gcTime: 0,
  head: () => ({
    meta: [
      { title: "Softmax - Complete Profile" },
      {
        name: "description",
        content: "Complete your Softmax profile to continue.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CompleteProfileRoute,
});

function CompleteProfileRoute() {
  const data = Route.useLoaderData();
  return (
    <VerifiedSession sessionUserId={data.sessionUserId}>
      <CompleteProfilePage key={data.sessionUserId} {...data} />
    </VerifiedSession>
  );
}
